import { ModalHeader, Stack, type ModalHeaderProps } from '@chakra-ui/react';
import { type FC } from 'react';

import { TrackedButton } from '$/components/common/Button/TrackedButton';
import { Icon } from '$/components/common/Icon';
import {
  type PiwikContentName,
  type PiwikContentPiece,
  type PiwikContentTarget,
} from '$/utils/piwikUtils';

interface ModalHeaderWithBackButtonProps extends ModalHeaderProps {
  headerText?: string | null;
  backButtonText?: string | null;
  displayBackButton?: boolean | null;
  trackingContentName?: PiwikContentName;
  trackingContentPiece?: PiwikContentPiece;
  trackingContentTarget?: PiwikContentTarget;
  onBackButtonClick?: () => void;
}

export const ModalHeaderWithBackButton: FC<ModalHeaderWithBackButtonProps> = ({
  headerText,
  backButtonText,
  displayBackButton = false,
  trackingContentName,
  trackingContentPiece,
  trackingContentTarget,
  onBackButtonClick,
  ...props
}) => {
  if (displayBackButton) {
    return (
      <ModalHeader px='10' pt='10' fontSize='h7' {...props}>
        <Stack pb='2'>
          <TrackedButton
            justifyContent='flex-start'
            gap='2'
            px='0'
            fontSize='sm'
            leftIcon={
              <Icon icon='arrow_right' w='14px' transform='rotate(180deg)' />
            }
            onClick={onBackButtonClick}
            variant='text'
            contentName={trackingContentName}
            contentPiece={trackingContentPiece}
            contentTarget={trackingContentTarget}
          >
            {backButtonText}
          </TrackedButton>
        </Stack>

        {headerText}
      </ModalHeader>
    );
  } else {
    return (
      <ModalHeader px='10' pt='10' fontSize='h7' {...props}>
        {headerText}
      </ModalHeader>
    );
  }
};
